export enum NumericalFunctionEnum {
    None = 0,
    Sum = 1,
    Average = 2,
    LastKnownValue = 3,
    FirstKnownValue = 4,
    LKVManualOverride = 5,
    Min = 6,
    Max = 7,
    StandardDeviation = 8,
    LastKnownHistoricalValue = 9,
    Downtime = 10,
    Runtime = 11,
    Count = 12,
    DataChanged = 13
}
